export const puzzles = [{ name: 'flower',
                    palette: 'primary',
                    paletteId: 0,
                    legend: [ 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
                              8, 8, 8, 8, 8, 8, 8, 8, 7, 7, 8, 8, 8, 8, 8, 8,
                              8, 8, 8, 8, 8, 8, 8, 7, 7, 7, 7, 8, 8, 8, 8, 8,
                              8, 8, 8, 8, 7, 7, 8, 7, 7, 7, 7, 8, 8, 8, 8, 8,
                              8, 8, 8, 7, 7, 7, 7, 7, 7, 7, 7, 8, 8, 8, 8, 8,
                              8, 8, 8, 7, 7, 7, 4, 4, 4, 7, 7, 7, 7, 8, 8, 8,
                              8, 8, 8, 7, 7, 4, 4, 4, 4, 4, 7, 7, 7, 7, 8, 8,
                              8, 8, 8, 8, 7, 4, 4, 4, 4, 4, 7, 7, 7, 7, 8, 8,
                              8, 8, 7, 7, 7, 4, 4, 4, 4, 4, 7, 7, 7, 7, 8, 8,
                              8, 8, 7, 7, 7, 7, 4, 4, 4, 7, 7, 7, 7, 8, 8, 8,
                              8, 8, 7, 7, 7, 7, 7, 7, 7, 7, 7, 5, 8, 8, 8, 8,
                              8, 8, 8, 7, 7, 7, 8, 7, 7, 7, 7, 5, 5, 8, 8, 8,
                              8, 8, 8, 8, 8, 8, 8, 7, 7, 7, 5, 5, 5, 8, 8, 8,
                              8, 8, 8, 8, 8, 8, 8, 8, 8, 5, 5, 5, 5, 5, 8, 8,
                              8, 8, 8, 8, 8, 8, 8, 8, 8, 5, 5, 8, 5, 5, 8, 8,
                              8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 5, 5, 8, 8 ]
                    },
                    { name: 'heart',
                      palette: 'primary',
                      paletteId: 0,
                      legend: [ 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3,
                                4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3,
                                4, 4, 4, 1, 1, 1, 1, 4, 4, 1, 1, 1, 1, 3, 3, 3,
                                4, 4, 1, 8, 8, 8, 8, 1, 1, 8, 8, 8, 8, 1, 3, 3,
                                4, 1, 8, 8, 0, 0, 8, 8, 8, 8, 8, 8, 8, 8, 1, 3,
                                4, 1, 8, 0, 0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 1, 3,
                                4, 1, 8, 0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 1, 3,
                                4, 1, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 1, 3,
                                4, 1, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 1, 3,
                                4, 4, 1, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 1, 3, 3,
                                4, 4, 4, 1, 8, 8, 8, 8, 8, 8, 8, 8, 1, 3, 3, 3,
                                4, 4, 4, 4, 1, 8, 8, 8, 8, 8, 8, 1, 3, 3, 3, 3,
                                4, 4, 4, 3, 3, 1, 8, 8, 8, 8, 1, 3, 3, 3, 3, 3,
                                4, 4, 3, 3, 3, 3, 1, 8, 8, 1, 3, 3, 3, 3, 3, 3,
                                4, 3, 3, 3, 3, 3, 3, 1, 1, 3, 3, 3, 3, 3, 3, 3,
                                3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, ]
                    },
                    { name: 'robot',
                      palette: 'primary',
                      paletteId: 0,
                      legend: [ 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9,
                                9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9,
                                9, 9, 9, 9, 9, 9, 1, 1, 1, 9, 9, 9, 9, 9, 9, 9,
                                9, 9, 9, 9, 9, 9, 1, 9, 1, 9, 9, 9, 9, 9, 9, 9,
                                9, 9, 9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 9, 9, 9,
                                9, 9, 1, 1, 4, 4, 4, 4, 4, 4, 4, 1, 9, 9, 9, 9,
                                9, 9, 1, 1, 4, 4, 6, 4, 4, 6, 4, 1, 9, 9, 9, 9,
                                9, 9, 1, 1, 4, 4, 4, 4, 4, 4, 4, 1, 9, 1, 9, 1,
                                9, 9, 1, 1, 4, 4, 4, 4, 4, 4, 4, 1, 9, 1, 1, 1,
                                9, 9, 9, 1, 1, 1, 1, 4, 4, 1, 1, 1, 9, 9, 1, 9,
                                9, 9, 9, 1, 1, 1, 1, 1, 1, 1, 1, 9, 9, 9, 1, 9,
                                9, 9, 9, 9, 9, 9, 1, 1, 1, 9, 9, 9, 9, 9, 1, 9,
                                9, 9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 1, 9,
                                9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9,
                                9, 1, 9, 9, 9, 1, 1, 1, 1, 1, 9, 9, 9, 9, 9, 9,
                                9, 1, 9, 9, 9, 1, 1, 1, 1, 1, 9, 9, 9, 9, 9, 9, ]
                      },
                      { name: 'bluey',
                        palette: 'bluey',
                        paletteId: 1,
                        legend: [ 5, 5, 5, 5, 5, 9, 5, 5, 5, 5, 9, 5, 5, 5, 5, 5,
                                  5, 5, 5, 5, 9, 9, 5, 5, 5, 5, 9, 9, 5, 5, 5, 5,
                                  5, 5, 5, 9, 9, 7, 9, 5, 5, 9, 7, 9, 9, 5, 5, 5,
                                  5, 5, 5, 9, 7, 7, 7, 9, 9, 7, 7, 7, 9, 5, 5, 5,
                                  5, 5, 5, 9, 9, 9, 9, 3, 3, 3, 9, 9, 9, 5, 5, 5,
                                  5, 5, 5, 9, 9, 0, 0, 0, 3, 0, 0, 0, 9, 5, 5, 5,
                                  5, 5, 5, 9, 9, 0, 1, 0, 3, 0, 1, 0, 9, 5, 5, 5,
                                  5, 5, 5, 9, 9, 0, 1, 0, 3, 0, 1, 0, 9, 5, 5, 5,
                                  5, 5, 5, 9, 9, 0, 0, 0, 7, 7, 7, 7, 7, 1, 1, 5,
                                  5, 5, 5, 9, 9, 3, 3, 3, 7, 7, 7, 7, 7, 7, 1, 5,
                                  5, 5, 5, 3, 3, 3, 3, 7, 7, 7, 7, 7, 7, 7, 7, 5,
                                  5, 5, 5, 3, 3, 3, 3, 7, 7, 7, 7, 7, 7, 7, 7, 5,
                                  5, 5, 5, 3, 3, 3, 3, 7, 7, 0, 0, 0, 0, 7, 7, 5,
                                  5, 5, 5, 3, 3, 3, 3, 7, 7, 8, 1, 1, 1, 5, 5, 5,
                                  5, 5, 5, 3, 3, 3, 3, 7, 7, 8, 8, 1, 1, 5, 5, 5,
                                  5, 5, 5, 3, 3, 3, 3, 7, 7, 7, 7, 7, 7, 5, 5, 5 ]
                            
                      }
                ];